<template>
  <div id="app">
    <Layout v-if="isRouterAlive"></Layout>
  </div>
</template>

<script>
import Layout from "@/framework/layout.vue";
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  components: {
    Layout,
  },
  created() {},
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
};
</script>

<style lang='less'>
@import url("./assets/rebate.less");
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
a {
  text-decoration: none;
}
* {
  margin: 0;
  padding: 0;
}
#app {
  background: #fcfafa;
  min-height: 100vh;
  overflow: auto;
}
.dui-navbar .navbar-header {
  line-height: 50px;
}
input {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue